import Toast from './Toast.vue';

export default {
    install(Vue, options) {
        let ToastPlugin = Vue.extend(Toast);
        let $vm = new ToastPlugin({ el: document.createElement('div') });
        document.body.appendChild($vm.$el);

        let _toast = {
            info(message) {
                $vm.showToast(message, 'info');
            },
            success(message) {
                $vm.showToast(message, 'success');
            },
            warning(message) {
                $vm.showToast(message, 'warning');
            },
            error(message) {
                $vm.showToast(message, 'error');
            },
            hide() {
                $vm.show = false;
            }
        };

        Vue.prototype.$toast = _toast;
    }
}


// WEBPACK FOOTER //
// ./app/plugins/toast/index.js